import { render, staticRenderFns } from "./edit-calendar-event.vue?vue&type=template&id=3095a7df&scoped=true&"
import script from "./edit-calendar-event.vue?vue&type=script&lang=js&"
export * from "./edit-calendar-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095a7df",
  null
  
)

export default component.exports